import _merge from 'lodash/merge';

import {
  progressDisplayPropertiesFistLevel,
  progressDisplayPropertiesSuccess
} from 'containers/Campaign/Progress/placeholder';

import { TOrbit } from '../../../i18n/TModules';
import { ProgressLevel, WizardState } from '../wizardModel';
import { CampaignFormValues } from '../wizardSubmission';
import {
  AdapterContext,
  baseValues,
  durationValues,
  positive,
  prizeComplete,
  toOutcome
} from './common';
import { toCampaignRule, toSavedRule, Translate } from './ruleAdapter';

/** The "How to participate" body the module requires and the wizard never asks. */
export const PROGRESS_PARTICIPATE_PLACEHOLDER = 'Complete each level to win its prizes.';

/** Levels need points that climb, absolute campaign points as the module stores them. */
export const milestoneErrors = (levels: ProgressLevel[], t: Translate): string[] => {
  const points = levels.map(level => level.points);
  if (points.some(value => !positive(value))) {
    return [t(`${TOrbit}.wizard.limits.positive`)];
  }
  const ascending = points.every(
    (value, index) => index === 0 || Number(value) > Number(points[index - 1])
  );
  return ascending ? [] : [t(`${TOrbit}.wizard.milestones.ascending`)];
};

export const levelPrizeErrors = (levels: ProgressLevel[], t: Translate): string[] =>
  levels.every(level => level.prizes.every(prizeComplete))
    ? []
    : [t(`${TOrbit}.wizard.prize.incomplete`)];

export const progressValues = (
  state: WizardState,
  context: AdapterContext
): CampaignFormValues => ({
  ...baseValues(state, 'progress', context, true),
  rules: state.triggers.map(trigger => toSavedRule(toCampaignRule(trigger, 'progress', context.t))),
  milestones: state.levels.map(level => ({
    ...progressDisplayPropertiesFistLevel,
    points: Number(level.points),
    outcomes: level.prizes.map(toOutcome)
  })),
  ...durationValues(state.limits),
  display_properties_en: _merge({}, progressDisplayPropertiesSuccess, {
    header: {
      value: { title: state.name.trim() },
      how_to_participate_tab: { value: { description: PROGRESS_PARTICIPATE_PLACEHOLDER } }
    }
  })
});
